// Listener na beforeinstallprompt musi byt registrovany na urovni modulu, ne
// az uvnitr Options.vue (mounted) - router (viz router/trainer.js) nema
// lazy-loading rout, takze se tenhle modul importuje uz pri startu appky.
// Diky tomu zachytime event i kdyz uzivatel v danou chvili neni na strance
// Options - kdyby listener visel az na komponente, o dřív vyvolaný event
// bychom prisli (bez zachyceneho reference na event nejde prompt() zavolat
// pozdeji).
let deferredPrompt = null;

window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    deferredPrompt = event;
});

window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
});

export function isInstallPromptAvailable() {
    return deferredPrompt !== null;
}

export function isIOS() {
    return /iPad|iPhone|iPod/.test(window.navigator.userAgent);
}

export async function promptInstall() {
    if (!deferredPrompt) {
        return;
    }
    const promptEvent = deferredPrompt;
    // event lze pouzit jen jednou - zahodit hned, dalsi klik uz nema co nabidnout
    deferredPrompt = null;
    promptEvent.prompt();
    await promptEvent.userChoice;
}
